(() => {
  const translations = {
    en: {
      inStock: 'In stock', inStockDetail: 'Ready to order. Stocked items normally dispatch in 1–2 business days.',
      out: 'Out of stock', outDetail: 'This selected SKU is unavailable. See the closest available alternatives below.',
      custom: 'Custom order', customDetail: 'Estimated dispatch date confirmed after order.', add: 'Add to cart',
      shorter: 'Closest shorter length', longer: 'Closest longer length', exactAlt: 'Same shade and length', alternative: 'Alternative line'
    },
    de: {
      inStock: 'Auf Lager', inStockDetail: 'Bestellbereit. Lagerware wird normalerweise innerhalb von 1–2 Werktagen versandt.',
      out: 'Nicht auf Lager', outDetail: 'Diese Variante ist nicht verfügbar. Die nächstgelegenen Alternativen finden Sie unten.',
      custom: 'Sonderanfertigung', customDetail: 'Voraussichtliches Versanddatum wird nach der Bestellung bestätigt.', add: 'In den Warenkorb',
      shorter: 'Nächstkürzere Länge', longer: 'Nächstlängere Länge', exactAlt: 'Gleiche Farbe und Länge', alternative: 'Alternative Linie'
    }
  };
  const language = () => document.documentElement.lang?.toLowerCase().startsWith('de') ? translations.de : translations.en;
  const valueFor = (variant, pattern) => (variant.options || []).find((option) => pattern.test(option.name || ''))?.value || '';
  const lengthOf = (variant) => {
    const raw = valueFor(variant, /length|länge/i) || variant.title || '';
    const inches = raw.match(/(10|12|14|16|18|20|22|24|26)\s*["”]/);
    if (inches) return Number(inches[1]);
    const cm = raw.match(/(25|30|35|40|45|50|55|60|65)\s*cm/i);
    return cm ? Number(cm[1]) / 2.5 : null;
  };
  const shadeOf = (variant) => valueFor(variant, /colou?r|shade|farbe/i).replace(/\s+/g, '').toLowerCase();

  function setupProduct(container) {
    const status = container.querySelector('[data-tgh-availability]');
    const dataNode = container.querySelector('[data-tgh-variant-status]');
    const submit = container.querySelector('[data-tgh-product-submit]');
    const variantInput = container.querySelector('.product-variant-id');
    const summary = container.querySelector('[data-tgh-selection-summary]');
    const quantityInput = container.querySelector('input[name="quantity"]');
    if (!status || !dataNode || !submit || !variantInput || status.dataset.ready) return;
    status.dataset.ready = 'true';
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch (_) { return; }
    const title = status.querySelector('[data-tgh-availability-title]');
    const detail = status.querySelector('[data-tgh-availability-detail]');
    const customWrap = container.querySelector('[data-tgh-custom-ack]');
    const customCheckbox = container.querySelector('[data-tgh-custom-checkbox]');
    const customProperty = container.querySelector('[data-tgh-custom-property]');
    const alternatives = container.querySelector('[data-tgh-alternatives]');
    const alternativesList = container.querySelector('[data-tgh-alternatives-list]');
    const availabilityAnchor = container.querySelector('[data-tgh-availability-anchor]');
    if (availabilityAnchor && alternatives) availabilityAnchor.append(status, alternatives);
    const copy = language();

    const money = (cents) => {
      try { return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: summary?.dataset.currency || 'EUR' }).format(Number(cents || 0) / 100); }
      catch (_) { return `€${(Number(cents || 0) / 100).toFixed(2)}`; }
    };
    const updateSummary = (variant) => {
      const options = summary?.querySelector('[data-tgh-selection-options]');
      if (!options) return;
      options.replaceChildren();
      (variant.options || []).forEach((option) => {
        const row = document.createElement('div'); const term = document.createElement('dt'); const value = document.createElement('dd');
        term.textContent = option.name; value.textContent = option.value; row.append(term, value); options.append(row);
      });
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      summary.querySelector('[data-tgh-selection-quantity]').textContent = String(quantity);
      summary.querySelector('[data-tgh-selection-total]').textContent = money(Number(variant.price || 0) * quantity);
    };
    const suggestion = (productTitle, variant, reason) => {
      const link = document.createElement('a');
      link.className = 'tgh-alternative';
      link.href = /[?&]variant=/.test(variant.url) ? variant.url : `${variant.url}${variant.url.includes('?') ? '&' : '?'}variant=${variant.id}`;
      const label = document.createElement('strong'); label.textContent = reason;
      const name = document.createElement('span'); name.textContent = `${productTitle} — ${variant.title}`;
      link.append(label, name); return link;
    };
    const renderAlternatives = (selected) => {
      if (!alternatives || !alternativesList) return;
      alternativesList.replaceChildren();
      if (selected.available || selected.custom) { alternatives.hidden = true; return; }
      const shade = shadeOf(selected); const length = lengthOf(selected); const results = [];
      const sameProduct = data.variants.filter((v) => v.available && !v.custom && shadeOf(v) === shade && lengthOf(v) !== null);
      const shorter = sameProduct.filter((v) => lengthOf(v) < length).sort((a, b) => lengthOf(b) - lengthOf(a))[0];
      const longer = sameProduct.filter((v) => lengthOf(v) > length).sort((a, b) => lengthOf(a) - lengthOf(b))[0];
      if (shorter) results.push([data.productTitle, shorter, copy.shorter]);
      if (longer) results.push([data.productTitle, longer, copy.longer]);
      (data.alternativeProducts || []).forEach((product) => {
        const pool = product.variants.filter((v) => v.available && !v.custom && shadeOf(v) === shade && lengthOf(v) !== null);
        const exact = pool.find((v) => lengthOf(v) === length);
        const altShort = pool.filter((v) => lengthOf(v) < length).sort((a, b) => lengthOf(b) - lengthOf(a))[0];
        const altLong = pool.filter((v) => lengthOf(v) > length).sort((a, b) => lengthOf(a) - lengthOf(b))[0];
        if (exact) results.push([product.title, exact, copy.exactAlt]);
        if (altShort) results.push([product.title, altShort, `${copy.alternative}: ${copy.shorter}`]);
        if (altLong) results.push([product.title, altLong, `${copy.alternative}: ${copy.longer}`]);
      });
      results.slice(0, 5).forEach((item) => alternativesList.append(suggestion(...item)));
      alternatives.hidden = false;
    };
    const update = () => {
      const variant = data.variants.find((item) => String(item.id) === String(variantInput.value));
      if (!variant) return;
      updateSummary(variant); renderAlternatives(variant);
      status.classList.toggle('is-in-stock', variant.available && !variant.custom);
      status.classList.toggle('is-contact', !variant.available);
      status.classList.toggle('is-custom', variant.custom);
      customWrap.hidden = !variant.custom;
      if (!variant.custom && customCheckbox) customCheckbox.checked = false;
      if (customProperty) customProperty.disabled = !variant.custom;
      if (variant.custom) { title.textContent = copy.custom; detail.textContent = copy.customDetail; }
      else if (variant.available) { title.textContent = copy.inStock; detail.textContent = copy.inStockDetail; }
      else { title.textContent = copy.out; detail.textContent = copy.outDetail; }
      submit.disabled = !variant.available || (variant.custom && !customCheckbox?.checked);
      submit.querySelector('span').textContent = copy.add;
    };
    customCheckbox?.addEventListener('change', update);
    quantityInput?.addEventListener('input', update); quantityInput?.addEventListener('change', update);
    container.addEventListener('change', () => { setTimeout(update, 20); setTimeout(update, 180); });
    new MutationObserver(update).observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    update();
  }

  function init(scope = document) {
    scope.querySelectorAll('product-info, .featured-product').forEach(setupProduct);
    scope.querySelectorAll('[data-tgh-share]').forEach((button) => {
      if (button.dataset.ready) return; button.dataset.ready = 'true';
      button.addEventListener('click', async () => {
        const url = button.dataset.url || location.href; const title = button.dataset.title || document.title;
        if (navigator.share) { try { await navigator.share({ title, url }); } catch (_) {} }
        else { await navigator.clipboard.writeText(url); const old = button.textContent; button.textContent = button.dataset.copied || 'Link copied'; setTimeout(() => { button.textContent = old; }, 1800); }
      });
    });
    scope.querySelectorAll('[data-tgh-cookie-preferences]').forEach((button) => {
      if (button.dataset.ready) return; button.dataset.ready = 'true';
      button.addEventListener('click', (event) => { event.preventDefault(); window.Shopify?.customerPrivacy?.showPreferences?.(); });
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('DOMContentLoaded', () => {
    let queued = false;
    new MutationObserver(() => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; init(); }); }).observe(document.body, { childList: true, subtree: true });
  });
})();
